import { SerialBuffer } from "eosjs/dist/eosjs-serialize";

const pushSymbol = SerialBuffer.prototype.pushSymbol;
SerialBuffer.prototype.pushSymbol = function(_a: any) {
	if (_a.name === "" && _a.precision == 0)
		this.pushArray([0, 0, 0, 0, 0, 0, 0, 0]);
	else
		pushSymbol.call(this, _a);
};
